<template>
  <el-dialog
    :width="width"
    :visible.sync="dialog"
    append-to-body
    @close="cancel"
  >
    <label slot="title">
      <i
        class="el-icon-edit-outline"
        style="font-size: 16px; font-weight: bold;"
      >
        <span style="margin-right: 5px;">
          {{ title }}
        </span>
      </i>
    </label>
    <el-card style="padding: 0 5% 0 5%">
      <slot name="content"></slot>
    </el-card>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="cancel()" size="small" v-if="showCancel">
          <i class="fa fa-close" />{{ cancelText }}
        </el-button>
        <el-button
          type="primary"
          @click="confirm()"
          size="small"
          v-if="showConfirm"
        >
          <i class="fa fa-check" />{{ confirmText }}
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "DialogBox",
  computed: {},
  props: {
    title: {
      type: String,
      default: "",
    },
    uniqueNum: {
      type: String,
      default: "",
    },
    dialogVisible: {
      type: Boolean,
      // default: false,
    },
    width: {
      type: String,
      default: "",
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
    showConfirm: {
      type: Boolean,
      default: true,
    },
    cancelText: {
      type: String,
      default: "取 消",
    },
    confirmText: {
      type: String,
      default: "确 定",
    },
  },
  watch: {
    dialogVisible: {
      handler(newVal, oldVal) {
        this.dialog = newVal;
      },
      deep: true, // 开启深度监听
    },
  },
  data() {
    return {
      tabLoading: false,
      ryxx: null,
      dialog: false,
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm");
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped></style>
